import { cn } from "@verse_core/shared_components/ClassName";

type CheckboxItemProps = {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  children: React.ReactNode;
  // False drops the card, for a checkbox inline in a form.
  bordered?: boolean;
};

/** Rebrand checkbox with its label, by default in a bordered card that is
 * clickable all over ("Form/Form Item" in Figma), e.g. the sign-up attestation. */
export function CheckboxItem({
  id,
  checked,
  onChange,
  children,
  bordered = true,
}: CheckboxItemProps) {
  return (
    <label
      htmlFor={id}
      className={cn(
        // font-normal: the provider app bolds every label.
        "tw-m-0 tw-flex tw-cursor-pointer tw-items-center tw-font-sohne tw-text-[14px] tw-font-normal tw-leading-[1.4] tw-text-verse-text-primary",
        bordered
          ? "tw-gap-[16px] tw-rounded-[8px] tw-border tw-border-solid tw-border-verse-border-primary tw-bg-white tw-p-[16px]"
          : "tw-gap-[8px]",
      )}
    >
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        className="tw-m-0 tw-h-[16px] tw-w-[16px] tw-shrink-0 tw-cursor-pointer tw-accent-verse-tide"
      />
      <span>{children}</span>
    </label>
  );
}
